import React,{ PureComponent } from 'react'
import {Select, Input, Modal, Table, Row, Col } from 'antd';
import PropTypes from 'prop-types';
// import { connect } from 'react-redux';
import { isEmpty, isEmptyObject } from "../../utils/utils";
import SearchApiService from "./SearchSelector.action";
import Lang from "@/components/Lang/Lang";
import _ from 'lodash';
import './index.less';
const { Search } = Input;
const { Option } = Select;

/**
 * 可搜索 + 弹窗的组件 todo 当时场景未需要编辑使用，此部分未完善 ，理想状态下将在 2.0 加上并 结合优化
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2021, all rights reserved. Essa.cn
 *
 *
 * @param title 标题
 * @param initValue: PropTypes.string, 打开显示文本
 * @param api 查询URL
 * @param searchField (当前搜索字段名)
 * @param onChange: PropTypes.func  回调选择项{ id}  { id,value } ,在getFieldDecorator 或者表单隐含此方法的包含中可忽略配置此项
 * @param onChangeRow: PropTypes.func  需要回调整行数据的用此方法
 *
 *
 * pageSize 搜索行数

 * field 显示文本字段名 :
 *    * field 传string 栏目增加一列名称, 如 field:  'typeName',
 *    * 传array栏目增加array数组 ,默认显示配置的第一列, 如field:  [{ title: '名称',dataIndex:'i18nKeyword'},{ title: '类型', dataIndex:'typeName'}], //todo 后续可优化
 *
 * disabled 是否不可编辑
 * idField 编号字段名称(回调值) 默认id，
 *
 * initListFlag 是否初始化一页数据, 默认 false
 *
 * getSelectedItem 供外部调，回调当前选择项
 *
 * 扩展：
 **/
class SearchSelector extends PureComponent{
    static propTypes = {
        title: PropTypes.string.isRequired,
        initValue: PropTypes.string,
        api: PropTypes.string.isRequired,
        searchField: PropTypes.string,
        pageSize: PropTypes.number,
        onChange: PropTypes.func,
        field:  PropTypes.any,
        disabled: PropTypes.bool,
        idField: PropTypes.string,
        type:PropTypes.string,
        initListFlag:PropTypes.bool,
    }
    static defaultProps = {
        title:'',
        initValue:'',
        api:'',
        pageSize: 10,
        searchField:'name',
        field:'name',
        disabled: false,
        idField:'id',
        type:'json',
        initListFlag:false,
        size:'default'
    };
    constructor(props){
        super(props)
        this.state = {
            loading:false,
            showModal: false,
            searchText: '',
            items:[],
            checkedItem: {},
            initItem:{},
            onCancelSelect: false, // 取消选中
            lastInitValue: null,
            showField:'', // 显示 及搜索 字段名,
            pagination: {
                showQuickJumper: true,
                pageSize:props.pageSize,
                current: props.pageNum||1,
            },
        }
        this.lastFetchId = 0;
        this.fetchSelectSearch = _.debounce(this.fetchSelectSearch, 200);  //避免search方法被多次不停的调用
    }
    /**
     * 搜索
     * @param lastInitValue 最后查询的值
     * @param initValue 打开组件时初始化显示值
     * @param typeFetch 搜索类型
     */
    onInitFetch(lastInitValue,initValue,typeFetch) {
        const { api, pageSize, idField,disabled,} = this.props;
        // let items = []
        // let checkedItem = {}
        const localJson = {}//todo  searchBoxLocalData[api]; //searchBox 查询本地数据是否有已有数据，无再查询
        if(isEmpty(initValue)){ //打开无值 时处理
            if(isEmptyObject(localJson)){ //如无数据 查询
                SearchApiService.fetch(api,pageSize, '', '').then((resp)=>this.showInitResult(resp.data,[],''));
            }else this.showInitResult(localJson,[],'');
        }
        // else { //打开需初始化 显示值 的 todo
      
        // }
    }

    /**
     * 进入时 赋值处理
     * @param result 搜索结果页
     * @param items  当前已选项
     * @param initValue 当前显示已选值
     */
    showInitResult = (result,items,initValue) =>{
        const {models,valid,success,paging }=result;
        const {pagination}=this.state;
        let itemList = [];
        const resList = [...models];
        if(resList&&resList.constructor===Array&&resList.length>0){
            if(!isEmpty(initValue)){
                const sIdField = this.props.idField;
                const flagInit = resList.find(element=>element[sIdField]==initValue);
                if(flagInit&&flagInit[sIdField]){ // 已选项在结果列表中，直接使用结果列表
                    itemList = resList;
                }else itemList = [...items,...resList]; // 合并已选项及结果列表
            } else itemList = resList;
        }
        this.setState({
            items: itemList,
            lastInitValue: initValue,
            pagination:{
                ...pagination,
                total:paging.total
            }
        })
    }
    /**
     * 查询 当前选项择
     * @param initValue 已选值
     * @param resList 结果列表
     * @returns {*}
     */
    getSelectedItem(){
        const { checkedItem } = this.state;
        console.log('了可以吗',checkedItem )
        return checkedItem||{}
    }
    // forSearchItem(initValue,resList){ //有子级内容时用
    //     const {idField} =this.props;
    //     for(let i=0,iLen=resList.length;i<iLen;i++) {
    //         const col = resList[i];
    //         const sCurVaule = col[idField];
    //         if ( sCurVaule== initValue || sCurVaule == Number(initValue)) return col;
    //         if (col.children && col.children.length && col.children.length > 0) {
    //             const res = this.forSearchItem(initValue, col.children);
    //             if(res&&res[idField]) return res;
    //         }
    //     }
    //     return;
    // }
    // 搜索弹窗
    handleShowModal(flag){
        this.setState({
            showModal: flag
        })
        this.onInitFetch(null,this.props.initValue,'1');
    }
    // 搜索事件 value:搜索值
    onSearch(value,pageSize,pageIndex=1){
        const { api, searchField, } = this.props;
        if(!isEmpty(api)&&!isEmpty(searchField)){
            this.setState({
                searchText: value
            })
            SearchApiService.fetch(api, pageSize, searchField, value,pageIndex).then((resp)=>this.showResult(resp.data))
        }
    }
    /**
     * 搜索结果
     * **/
    showResult(result){
        const {success,valid,models,paging } = result;
        if(success&&valid){
            const { pagination } = this.state;
            this.setState({
                items: models||[],
                pagination: {
                    ...pagination,
                    current:paging&&paging.pageNum||1,
                    total:paging&&paging.total||0
                }
            })
        }

    }
    // 单击 改变 选中事件
    handleOnChange = (record, checkedValue) => {
        let flag = true;
        const target = checkedValue?checkedValue.target:'';
        if(target.checked== false) flag = false; //  target.spellcheck; // 是否选中 刚选中的true 选中取消的false
        this.setState({
            checkedItem: flag?record:{},
            selectedRowKeys:[record[this.props.idField]],
        })
    };
    // 选中事件
    onClickedItem(item){
        const iId = item&&item[this.props.idField]?item[this.props.idField]:'';
        this.propBack(iId);
        this.setState({
            checkedItem: item,
            onCancelSelect: isEmptyObject(item),
        })
        this.handleShowModal(false)
        //    console.log('选中事件',item);
    }
    // 弹窗表格select选中事件
    onSelectChange = (selectedRowKeys, selectedRows) => {
        const index = selectedRowKeys.length-1
        const oneSelect = selectedRowKeys[index];
        this.setState({
            selectedRowKeys: !isEmpty(oneSelect)?[oneSelect]:[],
            checkedItem: !isEmpty(oneSelect)?selectedRows[index]:[],
        });
    };
    /**
     *  Select搜索用
     */
    onInputSelectChange(value,Option) {
        console.log("Select搜索用 value,Option",value,Option)
        const { showField } = this.state;
        this.propBack(value)
        let item = {
            id: value
        }
        item[showField] = Option&&Option.children?Option.children:'';
        this.setState({
            checkedItem: item,
            onCancelSelect: false,
        })
        //  console.log('Select搜索用',sKeywordTypeName);
    }
    /**
     * 切换页面
     * @param pagination 页码数据
     * @param filters 筛选
     * @param sorter  排序
     */
    handleTableChange = (pagination, filters, sorter) => {
        const current = pagination.current, pageSize= pagination.pageSize;
        const pager = { ...this.state.pagination };
              pager.current = current;
              pager.pageSize = pageSize;
        const { searchText } = this.state; //点击页面带当前搜索条件
        this.setState({
            pagination: pager,
        });
        this.onSearch(searchText,pageSize,current);
    }
    // 输出 类型
    getOption(field){
        const items = this.state.items;
        const enumChildren = [];
        if(items&&items.length&&items.length>0){
            items.forEach(opt=>{
                enumChildren.push(<Option key={opt[this.props.idField]}>{opt[field]}</Option>)
            })
        }
        return enumChildren;
    }
    fetchSelectSearch = value => {
        this.lastFetchId += 1;
        const fetchId = this.lastFetchId;
        // if(this.props.onChange)this.props.onChange(value)  此时不用回调值
        this.setState({
            items: [],
            checkedItem: {},  //重新搜索即清除原选择
            initItem:{}, //重新搜索即清除原选择
        });

        if (fetchId !== this.lastFetchId) {
            // for fetch callback order
            return;
        }
        this.setState({
            searchText: value
        })
        this.onSearch(value,this.props.pageSize)
    };
    propBack(value){
        //this.props.onChange(value);//回调值
        if(this.props.onChange){
            this.props.onChange(value);//回调值   
        }
        if(this.props.onChangeRow){
            const data = this.state.items.find(item=>item[this.props.idField]==value)||{}
            this.props.onChangeRow(data)
        }
    }
    componentDidMount(){
        if( this.props.onRef)  this.props.onRef(this);
        const { field } = this.props;
        let columns =[
        ];
        if(field.constructor===Array){
            columns = [...field];
            columns.forEach((column,i) => {
                if(column.cnTitleId){
                    let titleStr ='';
                    if(column.cnTitleId.constructor===Array){
                        const list = column.cnTitleId;
                        list.forEach((item,index)=>titleStr += Lang({id: item, default: column.cnTitle[index]})+'/');
                        titleStr = titleStr.substr(0,titleStr.length-1);
                    }else titleStr = Lang({id: column.cnTitleId, default: column.cnTitle});
                    column.title =titleStr;
                }

            })
        }else {
            columns.push({
                title: Lang({id: 'MingCheng', default: '名称'}),
                dataIndex: field,
            })
        }
        const showField = field&&field[0]&&field[0].dataIndex?field[0].dataIndex:field; // 显示 及搜索 字段名

        this.setState({
            columns: columns,
            showField: showField
        })
        if(this.state.initListFlag)this.onInitFetch(null,this.props.initValue,'1');
    }
    render() {
        const { title, disabled, initValue, idField,size } = this.props;
        const { lastInitValue,searchText, showModal, items, checkedItem,selectedRowKeys, initItem, onCancelSelect, columns, showField,loading,pagination } = this.state;
        const valueField = !isEmptyObject(checkedItem)?checkedItem[showField]:(!isEmptyObject(initItem)?initItem[showField]:'');
        if(lastInitValue&&lastInitValue!=initValue) this.onInitFetch(lastInitValue,initValue,'2');
        /// console.log('initValue',valueField)
        const rowSelection = {
            selectedRowKeys,
            onChange: this.onSelectChange,
            hideDefaultSelections: true,
            columnTitle: ' ', //不显示 全选
        };
        const sShowValue = onCancelSelect?'':(!isEmpty(valueField)?valueField:'');
        return (<div className={'SearchBoxWrap'}>
            <Row gutter={24}>
                <Col span={24}>
                    <div className={'SelectWrap'}>
                        <div className={'SelectBox'}>
                            <Select
                                loading={loading}
                                size={size}
                                showSearch
                                showArrow
                                allowClear
                                // placeholder={title}
                                disabled={disabled}
                                optionFilterProp="children"
                                onChange={this.onInputSelectChange.bind(this)} // 选中项
                                onSearch={this.fetchSelectSearch.bind(this)}
                                value={sShowValue?sShowValue:''}
                                notFoundContent={(<div>{Lang({id: 'ShuRuSouSuo',default:'输入搜索'})}</div>)}
                                className={sShowValue?'':'placeholderFont'} >
                                {!showModal&&this.getOption(showField)}
                            </Select>
                        </div>
                        <div className={'IconBox'} onClick={disabled?()=>console.log('禁用中'):()=>this.handleShowModal( true )}>
                            <i className="ri-search-2-line"></i>
                        </div>
                    </div>
                </Col>
            </Row>
            {showModal&& <Modal
                className="module-buyer-selector-wrap"
                width='800px'
                open={showModal}
                title= {title}
                okText={__getServerLanguage('QueDing')}
                cancelText={__getServerLanguage('QuXiao')}
                onOk={()=>this.onClickedItem(this.state.checkedItem)}
                onCancel={this.handleShowModal.bind(this,false)}
            ><Search placeholder={searchText?searchText:title}
                     style={{ width: 400,marginBottom:"10px" }}
                     size={size}
                     allowClear
                     onSearch={value =>this.onSearch(value,this.props.pageSize,1)} />
                <Table
                    columns={columns}
                    rowKey={record => record[idField]||record._id}    // KEY
                    dataSource={items}
                    pagination={pagination}
                    rowSelection={rowSelection}
                    scroll={{ y: 400 }}
                    onChange={this.handleTableChange} // 点击切换页码事件
                    onRow={record => {
                        return {
                            onClick:this.handleOnChange.bind(this,record), // 点击行
                            onDoubleClick: this.onClickedItem.bind(this,record),
                        };
                    }}
                />
            </Modal>}
        </div>)
    }
}

export default SearchSelector;
